//type
import { CarReview } from "../../api/reviews/type/reviewType"

//mui icon
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import StarIcon from '@mui/icons-material/Star';


interface ReviewCarCardProps {
    element: CarReview
}

const ReviewCarCard = ({element}:ReviewCarCardProps) => {
  return (
    <div>
      <div className="flex justify-between max-sm:gap-2">
        <div className='flex items-center gap-2'>
            <div className='text-[#7F7F7F] flex justify-center items-center border-2 border-[#7F7F7F]  rounded-full'>
                <PersonOutlineIcon />
            </div>
            <div>
                <p className='font-[600]'>{element.client.user.full_name}</p>
            </div>
        </div>
        <div className='flex flex-col items-center'>
          <div className="flex items-center gap-2 mt-2">
              <p>{element?.rating}</p>
              <StarIcon  className="!text-[#FF8F3A]"/>
          </div>
        </div>
      </div>
      <div className="mt-3 text-[#7F7F7F]">
        <p>{element?.comment}</p>
      </div>
    </div>
  )
}

export default ReviewCarCard